module.exports = "/spread_success-ce2c69cc145810d06a56a9ce214e5438.svg";